//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { headerComponent } from '@tidal/microservice-components';
import getUserErrorMessage from '../utils/getErrorMessage';

export default {
    name: 'NuxtError',
    components: {
        headerComponent,
    },
    props: {
        /** @type {import('vue').PropOptions<LoginWeb.ClientApiErrorWithOptionalLang>} */
        error: {
            type: Object,
            required: true,
        },
    },
    computed: {
        /** @returns {[string, any][]} */
        errorProps() {
            const keysToExclude = ['lang'];

            return Object.entries(this.error).filter(([key, value]) => {
                return !!value && !keysToExclude.includes(key);
            });
        },
        /** @returns {string} */
        message() {
            return getUserErrorMessage(this.error.lang, this.error.messageCode);
        },
    },
};
